export interface StockedProduct {
  hasUnlimitedStock?: boolean | null;
  stock?: number | null;
}

export function hasStock(product: StockedProduct): boolean {
  return Boolean(product.hasUnlimitedStock) || (product.stock ?? 0) > 0;
}
